<div class="instructions">
  <motif-icon
    [iconFunction]="IconoirInfoCircle"
    size="28"
    style="color: #000000"
  ></motif-icon>

  <div class="text-container">
    <h2 class="instructions-header">Instructions</h2>
    <h3 class="instructions-subtitle">Please ensure:</h3>
    <ol class="instructions-ol">
      <li>It is a single entity Trial Balance (TB) file.</li>
      <li>
        The sheet that contains the TB is on the first sheet of the file
        (including hidden sheets, if applicable).
      </li>
      <li>The TB contains at least 2 columns and a minimum of 5 rows.</li>
      <li>Links are broken (if applicable).</li>
    </ol>
    <h3 class="instructions-subtitle">Please note:</h3>
    <ol class="instructions-ol">
      <li>
        If there are 5 empty rows or less in a row or 3 empty columns or less in
        a row, the AI Agent will consider the data as one TB. If there are more
        than 5 empty rows in a row or more than 3 empty columns in a row, the AI
        Agent will not consider the data after the empty rows / columns.
      </li>
    </ol>
    <h3 class="instructions-subtitle">Please consider:</h3>
    <ol class="instructions-ol">
      <li>
        The AI agent will perform better if the headers of the columns are
        descriptive.
      </li>
      <li>
        The AI agent will get confused if there are multiple columns with
        headers with similar names. In particular, it is ideal that the account
        codes and account descriptions are the only columns whose titles contain
        the word "Account".
      </li>
      <li>
        The AI agent is more prone to making mistake when dealing with
        merged-cell headers and headers without names.
      </li>
    </ol>
  </div>
</div>
